import { BaseCameraApi } from '@inter-ikea-storageone/range';
export class PlatsaCameraApi extends BaseCameraApi {
    constructor(sceneManager, ipexViewer, entityManager, coreApi, canvas) {
        super(sceneManager, ipexViewer, entityManager, coreApi, canvas);
    }
}
//# sourceMappingURL=PlatsaCameraApi.js.map